// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"product-buttons_buttonsContainer__fJqkl","saveButtons":"product-buttons_saveButtons__RutJI","tooltipWrap":"product-buttons_tooltipWrap__yZWP0"};